import type { LinksHeaderDropdownComponent } from '@twisto/api-cms'

import { SecondaryDowndloadWidget } from '../download'
import { DropdownLinkHolder } from '../dropdown-link-holder'
import { LinkList } from '../link-list'

import * as styles from './header-dropdown.styles'

export const HeaderDropdown = ({
  link,
  content,
  widget,
}: LinksHeaderDropdownComponent) => {
  if (!link) {
    return null
  }

  const Dropdown = () => (
    <div className="dropdown" css={styles.dropdown}>
      <div css={styles.container}>
        <div css={styles.links}>
          {content?.map((list) => <LinkList key={list.id} {...list} />)}
        </div>
        <div>
          <SecondaryDowndloadWidget {...widget} />
        </div>
      </div>
    </div>
  )

  return (
    <DropdownLinkHolder fullDropdown link={link}>
      {content && content.length ? <Dropdown /> : null}
    </DropdownLinkHolder>
  )
}
